var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVisa(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 35,
    height: 20,
    viewBox: "0 0 35 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-387 -483) translate(309 269) translate(78 151) translate(0 63)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34.5,
    height: 20,
    fill: "#26337A",
    rx: 3
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFE",
    d: "M7.13 6.469L8.155.111 9.793.111 8.769 6.469 7.13 6.469M14.711.267C14.387.139 13.878 0 13.243 0c-1.62 0-2.76.863-2.77 2.098-.01.914.814 1.424 1.435 1.728.639.311.853.51.85.789-.004.425-.509.62-.98.62-.656 0-1.004-.095-1.543-.333l-.21-.101-.23 1.423c.382.177 1.09.33 1.825.339 1.722 0 2.84-.852 2.853-2.172.006-.724-.43-1.274-1.376-1.727-.572-.295-.924-.49-.92-.789 0-.264.297-.547.939-.547.536-.009.924.115 1.226.244l.147.073.222-1.378M16.893 4.215l.652-1.778c-.01.017.135-.368.218-.606l.11.548.38 1.836h-1.36zm2.02-4.098h-1.265c-.393 0-.687.113-.859.527l-2.433 5.827h1.72s.281-.784.345-.956l2.099.003c.049.222.199.953.199.953h1.52L18.915.117zM5.756.116L4.152 4.451 3.98 3.57C3.682 2.554 2.751 1.454 1.711.903l1.467 5.56h1.734L7.492.115H5.756",
    transform: "translate(7 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EC982D",
    d: "M2.664.112H.022L0 .243C2.056.77 3.416 2.041 3.98 3.57L3.406.648C3.307.245 3.02.126 2.664.112",
    transform: "translate(7 7)"
  }))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisa);
export default __webpack_public_path__ + "static/media/visa.3bdbebfce91baa92c745fb39768808d4.svg";
export { ForwardRef as ReactComponent };